module.exports = [{
      plugin: require('/tmp/2b45dc96/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
